import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { AdminRoutingModule } from './adm-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from "../../shared/shared.module";
import { NgxPrintModule } from 'ngx-print';
import { NgxEchartsModule } from 'ngx-echarts';
import { HttpClientModule } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';

import { dashboardComponent } from './dashboard/dash-component';
import { accprofileComponent } from './accounts/myProfile/profile-component';
import { adverstatsComponent } from './accounts/adver-stats/adver-stats';
import { accadvertisersComponent } from './accounts/advertisers/adver-component';
import { accpublishersComponent } from './accounts/publishers/pub-component';
import { addpublisherComponent } from './accounts/publisherAdd/add-publisher-component';
import { editpublisherComponent } from './accounts/publisherEdit/edit-publisher-component';
import { finconversionsComponent } from './finance/conversions/conv-component';
import { logComponent } from './log/log-component';
import { dnsComponent } from './settings/dns/dns-component';

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { importofferComponent } from './offers/import/import-offer-component';
import { campoverviewComponent } from './offers/alloffers/offers-component';
import { offerDetailsComponent } from './offers/offer-details/offer-details-component';
import { offerblacklistComponent } from './offers/black/black-component';
import { offerfraudComponent } from './offers/fraud/fraud-component';
import { topoffersComponent } from './offers/top-offers/top-offers';
import { settingsOfferComponent } from './offers/settings/settings';
import { NgxSliderModule } from 'ngx-slider-v2';
import { finpaymentsComponent } from './finance/payments/payments-component';
import { fininvoiceComponent } from './finance/invoice/invoice-component';

@NgModule({
  declarations: [
    dashboardComponent,
    accprofileComponent,
    adverstatsComponent,
    accadvertisersComponent,
    accpublishersComponent,
    addpublisherComponent,
    editpublisherComponent,
    finconversionsComponent,
    finpaymentsComponent,
    fininvoiceComponent,
    importofferComponent,
    campoverviewComponent,
    offerDetailsComponent,
    offerblacklistComponent,
    offerfraudComponent,
    settingsOfferComponent,
    topoffersComponent,
    logComponent,
    dnsComponent
   ],
  imports: [
    NgMultiSelectDropDownModule.forRoot(),
    CommonModule,
    AdminRoutingModule,
    NgxDatatableModule,
    SharedModule,
    NgbModule,
    NgbNavModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxPrintModule,
    NgxSliderModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
  ]
})
export class AdminModule { }
